import type { KeyValuePairsProps } from '../KeyValuePairs/types';

/**
 * KeyValuePairsContainer에서 반응형 너비 조정을 위한 CSS Grid의 grid-template-columns 값을 계산합니다.
 * 컴포넌트 스펙에 맞게 한 줄에 표시될 최대 컬럼 개수를 제한합니다.
 *
 * @param minColumnWidth - 컬럼의 최소 너비 (px)
 * @param maxColumnRepeat - 한 줄에 표시할 최대 컬럼 개수 (undefined일 경우 제한 없음)
 * @returns grid-template-columns 값
 */
export const getGridTemplateColumns = (
  minColumnWidth: KeyValuePairsProps['minColumnWidth'],
  maxColumnRepeat?: KeyValuePairsProps['maxColumnRepeat'],
) => {
  const baseTemplate = `minmax(min(100%, ${minColumnWidth}px), 1fr)`;

  if (!maxColumnRepeat) {
    return baseTemplate;
  }
  const maxColumnsConstraint = `calc(100% / ${maxColumnRepeat + 1})`; // N+1개가 한 줄에 들어가지 못하도록 너비 강제 처리 (최대 N개까지만 배치되도록 제한)

  return `minmax(min(100%, max(${minColumnWidth}px, ${maxColumnsConstraint})), 1fr)`;
};
